import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=56c4331c&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=56c4331c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4331c",
  null
  
)

export default component.exports